const ROUTES = {
  HOME: {
    path: '/',
    name: 'Home'
  },
};

export default ROUTES;